import { render, staticRenderFns } from "./GenericConfirmationDialog.vue?vue&type=template&id=65049ee8&"
import script from "./GenericConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./GenericConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports